import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.416 4.62592C17.7607 4.85568 17.8538 5.32134 17.624 5.66598L10.9651 15.6544L12.8834 17.5727L21.376 4.83393C21.6057 4.48929 22.0714 4.39616 22.416 4.62592C22.7607 4.85568 22.8538 5.32134 22.624 5.66598L13.624 19.166C13.4994 19.3529 13.2975 19.4742 13.0739 19.4963C12.8503 19.5184 12.6286 19.4392 12.4697 19.2803L10.1166 16.9272L8.62404 19.166C8.4994 19.3529 8.2975 19.4742 8.0739 19.4963C7.8503 19.5184 7.62855 19.4392 7.46967 19.2803L1.46967 13.2803C1.17678 12.9874 1.17678 12.5125 1.46967 12.2196C1.76256 11.9267 2.23744 11.9267 2.53033 12.2196L7.88343 17.5727L9.0349 15.8455L6.46967 13.2803C6.17678 12.9874 6.17678 12.5125 6.46967 12.2196C6.76256 11.9267 7.23744 11.9267 7.53033 12.2196L9.88343 14.5727L16.376 4.83393C16.6057 4.48929 17.0714 4.39616 17.416 4.62592Z"
        fill={colorValue}
      />
    </svg>
  );
};
